<template>
  <div>
    <div class="mandate-detail__header">
      <Heading class="mandate-detail__text" :level="3">
        {{ modalInfo.title }}
      </Heading>
      <template v-for="(text, index) in modalInfo?.details?.description">
        <BaseText
          :key="index"
          class="mandate-detail__text"
          :color="NebraskaColors.textSecondary"
          size="md"
        >
          {{ text }}
        </BaseText>
      </template>
    </div>
    <ButtonContainer>
      <template #button-primary>
        <ButtonPrimary
          data-testid="close-button"
          label="Entendi"
          @click="closeModal()"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IDetailModalProps } from '@/modules/wealth/types';
import {
  BaseText,
  ButtonPrimary,
  ButtonContainer,
  Heading
} from '@warrenbrasil/nebraska-web';

defineProps<{
  modalInfo: IDetailModalProps;
}>();

const closeModal = inject('closeDetailModal') as () => void;
</script>

<style lang="less" scoped>
.mandate-detail {
  &__text {
    margin-bottom: @size-spacing-x400;
    text-align: start;
  }
  &__header {
    margin-bottom: @size-spacing-x400;
    padding: 0 @size-spacing-x500 @size-spacing-x500 @size-spacing-x500;
  }

  @media (min-width: 1024px) {
    &__header {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
    &__wrapper {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
  }
}
</style>
